import { render } from "./comment-card.vue?vue&type=template&id=e8fd157b"
import script from "./comment-card.vue?vue&type=script&lang=js"
export * from "./comment-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__